import React from 'react'
import WaitingDrawer from 'src/consumer/components/LiveSessionPage/components/VideoCall/WaitingDrawer'
import CollapsedDrawerStrip from 'src/consumer/components/LiveSessionPage/components/VideoCall/CollapsedDrawerStrip'

export default function SessionSupportDock({
  renderDrawer = false,
  drawerOpen = false,
  showCollapsedStrip = false,
  onCollapse,
  onExpand,
  sessionStartTime,
  mentorName,
  mentorProfilePicId,
  hasMentorJoined,
  showOnlySupport,
  isCollapsed,
  supportQRCodeMediaId,
  engagementConfig,
  sessionSlug,
  shortKey,
  bookedEventId,
}) {
  return (
    <>
      {renderDrawer && (
        <WaitingDrawer
          open={drawerOpen}
          sessionStartTime={sessionStartTime}
          mentorName={mentorName}
          mentorProfilePicId={mentorProfilePicId}
          hasMentorJoined={hasMentorJoined}
          showOnlySupport={showOnlySupport}
          allowManualToggle={true}
          onClose={onCollapse}
          isCollapsed={isCollapsed}
          supportQRCodeMediaId={supportQRCodeMediaId}
          engagementConfig={engagementConfig}
          sessionSlug={sessionSlug}
          shortKey={shortKey}
          bookedEventId={bookedEventId}
        />
      )}
      {showCollapsedStrip && (
        <CollapsedDrawerStrip
          onClick={onExpand}
          mentorName={mentorName}
          mentorProfilePicId={mentorProfilePicId}
          showSupport={true}
        />
      )}
    </>
  )
}
